export const periods = {
    NEVER: '-1',
    ONE_WEEK: '1',
    TWO_WEEK: '2',
    THREE_WEEK: '3',
    FOUR_WEEK: '4',
};
